import { createSlice } from '@reduxjs/toolkit';

interface SidebarState {
  mobileMenuExpanded: boolean;
  categoriesOpen: boolean;
}

const initialState: SidebarState = {
  mobileMenuExpanded: false,
  categoriesOpen: false,
};

const modalSlice = createSlice({
  name: 'sidebar',
  initialState,
  reducers: {
    openMobileMenu: (state) => {
      return { ...state, mobileMenuExpanded: true };
    },
    closeMobileMenu: (state) => {
      return { ...state, mobileMenuExpanded: false };
    },
    openCategories: (state) => {
      return { ...state, categoriesOpen: true };
    },
    closeCategories: (state) => {
      return { ...state, categoriesOpen: false };
    },
  },
});

export const { openCategories, closeCategories, openMobileMenu, closeMobileMenu } =
  modalSlice.actions;
export default modalSlice.reducer;
